import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const WrapperBox = styled(Box)`
  position: relative;
  display: flex;
  overflow: visible;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    overflow: hidden;
  }
  ${themeMediaQuery('sm')} {
    overflow: visible;
  }
`;

export const ArtBox = styled(Box)`
  position: absolute;
  right: 0;
  top: -8vw;
  z-index: 2;
  width: 18%;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  display: block;
`;

export const TextWrapperBox = styled(Box)`
  position: absolute;
  width: 100%;
  top: 9vw;
  left: 50%;
  transform: translate(-50%, 0);
  ${themeMediaQuery('below_sm')} {
    top: 20vw;
  }
`;

export const StyledText = styled(Text)`
  text-align: center;
  max-width: 665px;
  margin: auto;
  ${themeMediaQuery('below_sm')} {
    max-width: 560px;
  }
  ${themeMediaQuery('sm')} {
    font-size: 65px;
    line-height: 55px;
  }
  ${themeMediaQuery('md')} {
    font-size: 85px;
    line-height: 81px;
  }
  ${themeMediaQuery('lg')} {
    font-size: 96px;
    line-height: 92px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 885px;
  }
`;
